import Icon from '@chegg-wt/core/components/Icon'
import styled from 'styled-components'
import { ButtonLink } from '@chegg/fanta'
import { adjust, themeBreakPoints } from '@chegg-wt/core/theme/theme'
import { Large, SpecialButtonLink } from '@chegg-wt/core/theme/fanta/button'
import { LargeLink } from '@chegg-wt/core/theme/sunkist/link'
import { values } from '@chegg-wt/core/theme/sunkist/spacing'
import { Heading3, Body } from '@chegg-wt/core/theme/sunkist/typography'

export const Container = styled.div`
  position: relative;
`

export const Message = styled.div<{ isIncomplete: boolean }>`
  display: flex;
  ${Body};
  border-radius: 6px;
  padding: 7px;
  width: 95%;
  background-color: ${({ isIncomplete }) =>
    isIncomplete
      ? ({ theme }) => theme.Colors.forInterface.interfaceColor07
      : ({ theme }) => theme.Colors.forInterface.interfaceColor08};
  @media (min-width: ${({ theme }) => adjust(themeBreakPoints.extraSmall(theme), -1)}) {
    width: 215px;
  }
`

export const MessageIcon = styled(Icon)<{ name: string }>`
  height: ${values.base};
  width: ${values.large};
  margin: 0;
  color: ${({ name }) =>
    name === 'exclamationPoint'
      ? ({ theme }) => theme.Colors.colorImportant
      : ({ theme }) => theme.Colors.forInterface.interfaceColor03};
`

export const MessageText = styled.div`
  ${Body};
  margin-left: ${values.xxsmall};
  margin-top: ${values.xxsmall};
`

export const XIcon = styled(Icon)`
  width: ${values.base};
  height: ${values.base};
  cursor: pointer;
  margin-right: 0;
`

export const ButtonContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 24px;
  height: 50px;
`
export const Button = styled(ButtonLink)`
  ${Large};
  width: 186px;
  padding: 0;
  text-align: center;
  cursor: pointer;
  border-color: ${({ theme }) => theme.Colors.primaryColor};
  background-color: ${({ theme }) => theme.Colors.primaryColor};
  &:hover {
    border-color: ${({ theme }) => theme.Colors.forFonts.fColor16};
    background-color: ${({ theme }) => theme.Colors.forFonts.fColor16};
  }
`

export const OrangeButton = styled(SpecialButtonLink)`
  width: 270px;
`

export const Header = styled.h3`
  ${Heading3};
  margin: 20px 0;
`

export const BoldHeader = styled.h3`
  ${Heading3};
  font-weight: bold;
  margin: 20px 0;
`

export const ChevronRight = styled(Icon)`
  width: 35px;
  height: 35px;
`

export const SunkistLink = styled.a`
  ${LargeLink};
  margin: 20px 0;
`
